import React, {useState} from 'react';

const ProductContext = React.createContext();

const ProductProvider = (props) => {
    const [facultyDetails, setFacultyDetails] = useState({id:'',
        title:"",
        subTitle:"",
        name:"",
        category:"",
        avatarSrc:"",
        dob:"",
        pob:"",
        emailID:"",
        contact:"",
        province:"",
        academicQualification:[],
      booksPublished:[],
      researchArticles:[],
      generalArticles:[],
      bookReviews:[],
        currentTeaching:"",
        previousTeaching:""
      });

   
    return (
        <ProductContext.Provider value={{
            facultyDetails, 
            setFacultyDetails
        }}>
        {props.children}
        </ProductContext.Provider>
    )
}

export {ProductProvider, ProductContext};
